import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Check from '@material-ui/icons/Check'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import AcceptButton from 'components/atoms/buttons/AcceptButton'
import CloseButton from 'components/atoms/buttons/CloseButton'

const styles = theme => ({
  root: {
    height: '100%',
    color: theme.palette.white,
    backgroundColor: theme.palette.tertiary.toast,
  },
  wrapper: {
    ...theme.components.toast,
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },
  open: {
    opacity: 1,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(2),
  },
  closeButton: {
    marginRight: theme.spacing(1),
  },
})

const SelectedRequestToast = ({ classes, data, open }) => (
  <div className={classes.root}>
    <section className={classNames(classes.wrapper, open && classes.open)}>
      <div className={classes.content}>
        <Check />
        <Typography className={classes.text}>
          {data.data.length} user{data.data.length !== 1 ? 's' : ''} requesting
          to join your project
        </Typography>
      </div>
      <div className={classes.content}>
        <CloseButton
          className={classes.closeButton}
          iconClassName={classes.closeIcon}
          onClick={data.onDeny}
        />
        <AcceptButton
          iconClassName={classes.acceptIcon}
          onClick={data.onAccept}
        />
      </div>
    </section>
  </div>
)

SelectedRequestToast.propTypes = {
  data: PropTypes.any,
  open: PropTypes.bool,
  classes: PropTypes.object,
  handleClose: PropTypes.func,
}

export default withStyles(styles)(SelectedRequestToast)



// WEBPACK FOOTER //
// ./src/components/atoms/toasts/SelectedRequestToast.js